var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNewWidthInside3Fa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "366px",
    height: "411px",
    viewBox: "0 0 366 411",
    enableBackground: "new 0 0 366 411",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t@font-face {\r\n\t\t\tfont-family: \"proximanova-nova\";\r\n\r\n\t\t\tsrc: url('https://doopsalta2.com/Fonts/proxima-nova-three.woff2') format('woff2'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.woff') format('woff'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.otf') format('opentype');\r\n\t\t\tfont-style: normal;\r\n\t\t\t}\r\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 13.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4,
    y: 36.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 53.3,
    y1: 210,
    x2: 261.5,
    y2: 210
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "56,218.9 40.4,210 56,201  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "258.9,218.9 274.5,210 258.9,201  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 53.3,
    y1: 63.4,
    x2: 261.5,
    y2: 63.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "56,72.3 40.4,63.4 56,54.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "258.9,72.3 274.5,63.4 258.9,54.4  "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 53.3,
    y1: 350.4,
    x2: 261.5,
    y2: 350.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "56,359.3 40.4,350.4 56,341.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "258.9,359.3 274.5,350.4 258.9,341.4  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M339.3,65.7c0-1.6,0-3.2-0.1-4.7c-0.1-1.6-0.2-3.1-0.4-4.5c-0.2-1.4-0.5-2.8-0.8-4s-0.8-2.4-1.5-3.3l2-1.3 c0.7,1.1,1.2,2.3,1.7,3.7c0.4,1.4,0.8,3,1,4.8c0.1,0.8,0.2,1.5,0.2,2.4c0.1,0.8,0.1,1.6,0.1,2.4c0,0.8,0.1,1.6,0.1,2.4 s0,1.5,0,2.2H339.3z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M344.6,194.2c0,0,0,0.1,0,0.2c0,0.1,0,0.3,0.1,0.6c0,0.2,0,0.5,0.1,0.8c0,0.3,0,0.6,0,0.9 c0,1.9-0.5,3.3-1.3,4.3v0c-0.4,0.5-0.9,0.9-1.5,1.1c-0.6,0.3-1.2,0.4-1.9,0.4c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.1-0.9-0.3 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0.1,0.8,0.2,1.5,0.2,2.4c0.1,0.8,0.1,1.6,0.1,2.4c0,0.8,0.1,1.6,0.1,2.4s0,1.5,0,2.2h-2.4 c0-1.3,0-2.6,0-3.9s-0.1-2.5-0.2-3.7c-0.1-1.2-0.3-2.4-0.5-3.5c-0.2-1.1-0.5-2.1-0.9-3c-0.2-0.4-0.4-0.8-0.5-1.2s-0.4-0.8-0.7-1.2 l2-1.3c0.1,0.2,0.3,0.4,0.4,0.6s0.2,0.4,0.3,0.7c0.1,0.2,0.2,0.5,0.3,0.7s0.2,0.5,0.4,0.8c0.2,0.4,0.4,0.8,0.6,1.2 c0.2,0.3,0.4,0.6,0.6,0.9c0.2,0.3,0.5,0.4,0.8,0.6c0.3,0.1,0.7,0.2,1.2,0.2c0.3,0,0.6,0,0.9-0.2s0.5-0.3,0.6-0.5 c0.2-0.2,0.3-0.4,0.4-0.6c0.1-0.2,0.2-0.5,0.2-0.8c0.1-0.3,0.1-0.5,0.1-0.8s0-0.6,0-0.8c0-0.3,0-0.7-0.1-1c0-0.3-0.1-0.6-0.1-0.8 L344.6,194.2z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M346.5,334.4c0.1,0.7,0.2,1.3,0.3,1.9c0.1,0.6,0.1,1.1,0.1,1.6c0,1.6-0.3,2.7-1,3.5 c-0.3,0.4-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.4,0.3c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.5-0.3-0.7-0.5 c-0.2-0.2-0.4-0.4-0.6-0.7l-0.2,0.4c-0.4,0.4-0.8,0.8-1.3,1c-0.5,0.2-1,0.3-1.6,0.3c-0.3,0-0.6,0-0.8-0.1c-0.2,0-0.5-0.1-0.7-0.2 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0.1,0.8,0.2,1.6,0.2,2.4c0.1,0.8,0.1,1.6,0.1,2.4c0,0.8,0.1,1.6,0.1,2.4c0,0.8,0,1.5,0,2.3 h-2.4c0-0.3,0-0.7,0-1c0-0.4,0-0.7,0-1c0-1.2,0-2.3-0.1-3.4c-0.1-1.1-0.2-2.2-0.4-3.3c-0.2-1-0.4-2-0.6-3c-0.2-1-0.5-1.9-0.9-2.7 c0,0,0-0.1-0.1-0.2c0,0,0-0.1,0-0.1c-0.1-0.3-0.3-0.6-0.4-0.9c-0.1-0.3-0.3-0.6-0.5-0.9l2.2-1.3c0.1,0.1,0.1,0.2,0.2,0.4 c0.1,0.1,0.2,0.3,0.2,0.5s0.2,0.3,0.2,0.5c0.1,0.2,0.2,0.3,0.2,0.5c0.2,0.4,0.4,0.8,0.6,1.2c0.2,0.5,0.4,0.9,0.6,1.3 c0.2,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.4,0.4,0.6,0.5s0.5,0.1,0.9,0.1c0.3,0,0.5,0,0.6-0.1c0.1-0.1,0.3-0.2,0.4-0.4 c0.2-0.3,0.4-0.6,0.5-1.1s0.2-1.1,0.2-1.7c0-0.1,0-0.2,0-0.5c0-0.2,0-0.5,0-0.7c0-0.2,0-0.5,0-0.7c0-0.2,0-0.3,0-0.4l2.4-0.3 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0.1,0.4c0,0.2,0,0.4,0.1,0.7c0,0.5,0.1,1,0.2,1.6c0.1,0.6,0.2,1,0.3,1.5 c0.1,0.3,0.2,0.5,0.3,0.7c0.1,0.2,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.5-0.1 c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.2s0.1-0.2,0.1-0.4s0.1-0.4,0.1-0.6s0-0.5,0-0.8c0-0.4,0-0.8-0.1-1.3 c-0.1-0.5-0.1-1.1-0.3-1.8L346.5,334.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNewWidthInside3Fa);
export default __webpack_public_path__ + "static/media/help_new_width_inside_3_fa.81b784bbaa4d68b987911706f9d76bb5.svg";
export { ForwardRef as ReactComponent };